import React from 'react'

import { useActions, useAppSelector } from 'redux/hooks'

import { setPriceSourceAction } from 'redux/active/actions'

import { PriceDropdownGroup } from 'components/misc/PriceDropdown'

const ChangePriceSource = () => {
  const priceSource = useAppSelector(state => state.active.priceSource)
  const [setPriceSource] = useActions(setPriceSourceAction)

  const handleChangePriceSource = (index: number, option: any) => {
    const updatedPriceSources = [...priceSource]

    updatedPriceSources[index] = option

    setPriceSource(updatedPriceSources)
  }

  return (
    <PriceDropdownGroup
      priceSources={[
        { priceSource: priceSource[0], changePriceSource: (option: any) => handleChangePriceSource(0, option) },
        { priceSource: priceSource[1], changePriceSource: (option: any) => handleChangePriceSource(1, option) },
      ]}
    />
  )
}

export default ChangePriceSource
